import React from 'react';
import { View as ViewBase } from 'react-native';
import { useTheme } from '../../hooks';
export const View = ({ children, style = {}, transparent = false, ...rest }) => {
    const theme = useTheme();
    return (React.createElement(ViewBase, { style: [
            {
                backgroundColor: transparent ? 'transparent' : theme?.colors?.backgroundPrimary,
            },
            ...(Array.isArray(style) ? style : [style]),
        ], ...rest }, children));
};
//# sourceMappingURL=View.js.map